// srcset widths for event section cards, about 320px wide on desktop
export const EVENT_CARD_IMAGE_WIDTHS = [320, 480, 640, 960, 1280] as const;
